import { useDispatch, useSelector } from "react-redux";
import {
  selectIsInvoicePaymentBlocked,
  startInvoicePaymentTimeout,
} from "slices/payment/paymentSlice";


export const usePaymentBlocked = (invoiceNumber: string): [boolean, () => void] => {
  const dispatch = useDispatch();
  const isBlocked = useSelector(selectIsInvoicePaymentBlocked(invoiceNumber));

  const setBlocked = () =>
    dispatch(startInvoicePaymentTimeout(invoiceNumber));

  return [isBlocked, setBlocked];
};